var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.table)?_c('v-select',{attrs:{"filled":"","hide-details":!_vm.isRequired,"label":_vm.title,"items":_vm.fields,"item-text":"name","item-value":"name","rules":_vm.rules,"value":_vm.value,"clearable":""},on:{"input":_vm.onChange}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }